import { authRoutes } from '@booking-portal/modules/auth/auth-routes';
import { bookingFlowCheckoutRoutes } from '@booking-portal/modules/booking-flow-checkout/booking-flow-checkout-routes';
import { bookingFlowRoutes } from '@booking-portal/modules/booking-flow/booking-flow-routes';
import { customerPortalRoutes } from '@booking-portal/modules/customer-portal/customer-portal-routes';
import { setupGuards } from '@booking-portal/router/guards/guards';
import {
  type IAppRouteMeta,
  navigationNames,
} from '@booking-portal/router/router-constants';
import {
  createRouter,
  createWebHistory,
  type RouteLocationRaw,
  type RouteRecordRaw,
} from 'vue-router';

export type IAppRoutes = Readonly<RouteRecordRaw & { meta?: IAppRouteMeta }>[];

export const locationIdRoutePrefix = '/:locationId(\\d+)';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      name: navigationNames.notFound,
      path: '/',
      alias: ['/404'],
      strict: true,
      component: () =>
        import('@booking-portal/modules/base/pages/NotFound.vue'),
    },
    {
      name: navigationNames.serverError,
      path: '/server-error',
      component: () =>
        import('@booking-portal/modules/base/pages/GenericServerErrorPage.vue'),
    },
    {
      name: navigationNames.forbidden,
      path: '/forbidden',
      component: () => import('../modules/base/pages/ForbiddenPage.vue'),
    },
    {
      name: navigationNames.errorInvalidDomain,
      path: '/invalid-domain',
      component: () =>
        import('../modules/base/pages/ErrorInvalidDomainPage.vue'),
    },
    ...authRoutes,
    {
      path: locationIdRoutePrefix,
      component: () =>
        import('@booking-portal/modules/base/pages/LocationIdVerificationPage.vue'),
      children: [...bookingFlowCheckoutRoutes, ...bookingFlowRoutes],
    },
    ...customerPortalRoutes,
    {
      path: '/:pathMatch(.*)*',
      component: () =>
        import('@booking-portal/modules/base/pages/NotFound.vue'),
    },
  ] as IAppRoutes,
});

// Adding guards to the router AFTER the session check guard. The session check needs to be the first guard!
setupGuards(router);

/**
 * Placeholder for NUXTs `navigateTo` method. Used to reduce amount of work after switching from Nuxt to Vue
 * @param to
 */
export function navigateTo(to: RouteLocationRaw) {
  return router.push(to);
}

/**
 * @deprecated. Use named exports "router" instead
 */
export default router;
